import { GrowthBook } from "@growthbook/growthbook-react";
import { pageEvent } from "@acko-tech/building-blocks.ui.acko-analytics";
import { abFeatureNameAndVal } from "segments/eventActions/misc";
import { abFeatureNameAndValR2D2 } from "@analytics/car/actions/landing";
export const GROWTHBOOK_CONSTANTS = {
  ACKODEV: {
    apiHost: "https://growthbook-api.internal.ackodev.com",
    clientKey: "sdk-JkAcfiqoopJ9cDy"
  },
  MASTER: {
    apiHost: "https://growthbook-api.internal.ackodev.com",
    clientKey: "sdk-JkAcfiqoopJ9cDy"
  },
  PRODUCTION: {
    apiHost: "https://ab.acko.com/",
    clientKey: "sdk-GuTiLkcZIIvfH0lL"
  },
  LOCALHOST: {
    apiHost: "https://growthbook-api.internal.ackodev.com",
    clientKey: "sdk-JkAcfiqoopJ9cDy"
  }
};

const credentials =
  GROWTHBOOK_CONSTANTS[(process.env.ENVIRONMENT || "").toUpperCase()];
console.log(process.env.ENVIRONMENT, "env");
const growthbook = new GrowthBook({
  apiHost: credentials?.apiHost,
  clientKey: credentials?.clientKey,
  enableDevMode: process.env.ENVIRONMENT === "production" ? false : true,
  trackingCallback: (experiment, result) => {
    pageEvent("ab_testing", {
      experiment_id: experiment.key,
      variation_id: result.key
    });
  }
});

export const isGrowthBookReady = () => {
  return growthbook.ready;
};

export const getFeatureValue = ({ dispatch, flagName }) => {
  const flagValue = growthbook.isOn(flagName);
  dispatch(
    abFeatureNameAndVal({
      experiment_name: flagName,
      variant_name: `${flagValue}`
    })
  );
  dispatch(
    abFeatureNameAndValR2D2({
      edata: {
        experiment_name: flagName,
        variant_name: `${flagValue}`
      }
    })
  );
  return flagValue;
};

export const loadGrowthbookFeatures = () => {
  return Promise.race([
    growthbook.loadFeatures(),
    new Promise(resolve => {
      setTimeout(() => {
        resolve("fallback timeout executed");
      }, 600);
    })
  ]);
};

export default growthbook;

// Usage:
// At the page level add following snippet to the getInital props method and use the feature to conditionally render components:
// CarPurchaseJourney.getInitialProps = async (ctx: NextPageContext) => {
//   await growthbook.loadFeatures();
// At component level add following snippet to access the feature flag:
// const value = growthbook.getFeatureValue("fresh-car-prequote", "fallback");
// };
